import { providerStatusColors } from '../resources/constantsCodes/constants';
import { SxProps, Theme } from '@mui/material/styles';
import { OptionType, SelectValueType } from '../components/Select';

export const getProviderStatusColor = (status: SelectValueType, isSelector?: boolean): string => {
    if (String(status) === '1' || String(status) === '0') {
        return String(status) === '1' ? '#4caf50' : '#F44336';
    }
    if (!status) return '#808080';
    return isSelector && String(status) === 'active' ? '#000000' : providerStatusColors[String(status)] || '#808080';
};

export const getProviderStatusOptionStyle = (option: OptionType): SxProps<Theme> | null => {
    const color = getProviderStatusColor(option.value);
    if (!color) return null;
    
    return {
        color: color,
    };
};

export const getProviderStatusCellStyle = (status: string | number | null | undefined): React.CSSProperties => {
    const color = getProviderStatusColor(status);

    return {
        color
    };
}
